module.exports = {
      id: "abb4455cd15392d712edcb8a8910d841roofShape-saddle.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#abb4455cd15392d712edcb8a8910d841roofShape-saddle.svg",
      toString: function () {
        return this.url;
      }
    }